document.addEventListener("DOMContentLoaded", function () {

  /* =========================
     ELEMENTS
  ========================== */

  const overlay = document.getElementById("mug-design-overlay");
  const hiddenDesignInput = document.getElementById("selected-mug-design");
  const hiddenTextInput = document.getElementById("mug-text-property");

  const designItems = document.querySelectorAll(".single-mug-design-item");
  const textInput = document.getElementById("mug-custom-text");
  const textOverlay = document.querySelector(".customText");

  const form = document.querySelector('form[action^="/cart/add"]');

  if (!overlay || !hiddenDesignInput || !form) return;

  /* =========================
     DESIGN SELECTION
  ========================== */

  designItems.forEach(item => {
    item.addEventListener("click", () => {

      const designUrl = item.dataset.design;
      if (!designUrl) return;

      // Active state
      designItems.forEach(i => i.classList.remove("active"));
      item.classList.add("active");

      // Show design on mug
      overlay.src = designUrl;
      overlay.style.display = "block";

      // Save to cart
      hiddenDesignInput.value = designUrl;
    });
  });

  /* =========================
     TEXT LOGIC
  ========================== */

  if (!textInput || !textOverlay || !hiddenTextInput) return;

  const DEFAULT_TEXT = "double";
  function getMaxFontByScreen() {
  const w = window.innerWidth;
  if (w <= 768) return 8; 
  if (w <= 1024) return 14;
  return 22;
  }
  const MIN_FONT = 10;

  function fitText() {
    let fontSize = getMaxFontByScreen();
    textOverlay.style.fontSize = fontSize + "px";

    while (
      textOverlay.scrollWidth > textOverlay.offsetWidth &&
      fontSize > MIN_FONT
    ) {
      fontSize--;
      textOverlay.style.fontSize = fontSize + "px";
    }
  }

  // Initial default text
  textOverlay.textContent = DEFAULT_TEXT;
  hiddenTextInput.value = DEFAULT_TEXT;
  fitText();

  textInput.addEventListener("input", function () {
    const value = this.value.trim();
    const finalText = value === "" ? DEFAULT_TEXT : value;

    textOverlay.textContent = finalText;
    hiddenTextInput.value = finalText;

    fitText();
  });

  /* =========================
     VALIDATION (IMPORTANT)
  ========================== */

  form.addEventListener("submit", function (e) {
    if (!hiddenDesignInput.value) {
      e.preventDefault();
      alert("Please select a design before adding to cart.");
    }
  });

});

document.querySelectorAll('.cart-item__details .product-option').forEach(option => {
  const label = option.querySelector('dt')?.textContent?.trim();

  if (label === 'Mug Design:' || label === 'Custom Text:') {
    option.style.display = 'none';
    console.log('HIDDEN:', label);
  } else {
    console.log('KEPT:', label);
  }
});